import React from 'react';
import { ThemeProvider as StyledThemeProvider } from 'styled-components';
import { theme } from '../tokens';
import { GlobalStyles } from './GlobalStyles';
import { ToastProvider } from '../components/Toast';

/**
 * Theme Provider wraps the application with:
 * - Styled-components ThemeProvider (makes theme available via props)
 * - GlobalStyles (CSS reset and base styles)
 * - ToastProvider (global toast notifications)
 */
export const ThemeProvider = ({ children }) => {
  return (
    <StyledThemeProvider theme={theme}>
      <GlobalStyles />
      <ToastProvider>
        {children}
      </ToastProvider>
    </StyledThemeProvider>
  );
};

export default ThemeProvider;
